import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import moment from 'jalali-moment';
import { SearchContactUs, SearchSubject, SearchDepartment } from '../../../utils/api';
import useToastNotification from '../../../hooks/useToastNotification';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Form from 'react-bootstrap/Form';

function Banner() {
    const { showError } = useToastNotification();
    const [date, setDate] = useState(null);
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [departman, setDepartman] = useState('');
    const [subject, setSubject] = useState('');
    const [subjectItems, setSubjectItems] = useState([]);
    const [departmanItems, setDepartmanItems] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    const loadContactUs = async (page = pageIndex, size = pageSize, filters = {}) => {
        setLoading(true);
        try {
            const response = await SearchContactUs({
                pageIndex: page,
                pageSize: size,
                ...filters, // اضافه کردن فیلترها
            });
            setItems(response.data.data.items);
            setTotalRecords(response.data.data.total);
        } catch (error) {
            showError("خطا در بارگذاری اطلاعات");
        } finally {
            setLoading(false);
        }
    };

    const loadDepartman = async () => {
        let res = await SearchDepartment({})
        setDepartmanItems(res.data.data.items)
    }
    const loadSubject = async () => {
        let res = await SearchSubject({})
        setSubjectItems(res.data.data.items)
    }

    useEffect(() => {
        loadDepartman();
        loadSubject();
    }, []);
    useEffect(() => {
        loadContactUs();
    }, [pageIndex, pageSize]);

    const onPageChange = (event) => {
        setPageIndex(event.page);
        setPageSize(event.rows);
    };
    const handleFilterChange = (filters) => {
        const { subjectId, departmentId, date } = filters;
    
        loadContactUs(pageIndex, pageSize, {
            subjectId: subjectId || null,
            departmentId: departmentId || null,
            // date: date || null,
        });
    };


    const formatJalaliDate = (date) => {
        return moment(date).locale('fa').format('YYYY/MM/DD');
    };

    const dateBodyTemplate = (rowData) => {
        return formatJalaliDate(rowData.createDate);
    };

    // قالب اسکلتون
    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };
    const handlePagination = (event) => {
        // Update the pageIndex and pageSize based on the event
        setPageIndex(event.page + 1);
        setPageSize(event.rows);

        // Trigger a data fetch for the new page
        loadContactUs(event.page, event.rows);
    };

    return (
        <div>
            <div className='row gx-4'>
                {/* <Form.Group className="mb-3 col-md-2 col-lg-2 col-sm-12">
                    <Form.Label>تاریخ</Form.Label>
                    <DatePicker
                        weekDays={weekDays}
                        value={date}
                        onChange={(newDate) => {
                            setDate(convertDateToPersian(newDate.toDate()))
                            handleFilterChange(); // اعمال تغییر فیلتر
                        }}
                        calendar={persian}
                        locale={persian_fa}
                    />
                </Form.Group> */}

                <Form.Group className="mb-3 col-md-2 col-lg-2 col-sm-12">
                    <Form.Label>موضوع</Form.Label>
                    <Form.Select type="text" value={subject} onChange={(e) => {
                         const newSubject = e.target.value;
                         setSubject(newSubject);
                         handleFilterChange({ subjectId: newSubject, departmentId: departman, date });
                    }}>
                        <option value="">همه</option> {/* گزینه همه */}

                        {subjectItems.map(item =>
                            <option value={item.id}>{item.title}</option>
                        )}
                    </Form.Select>

                </Form.Group>
                <Form.Group className="mb-3 col-md-2 col-lg-2 col-sm-12">
                    <Form.Label>دپارتمان</Form.Label>
                    <Form.Select type="text" value={departman} onChange={(e) => {
                          const newDepartman = e.target.value;
                          setDepartman(newDepartman);
                          handleFilterChange({ subjectId: subject, departmentId: newDepartman, date });
                    }}>
                        <option value="">همه</option> {/* گزینه همه */}
                        {departmanItems.map(item =>
                            <option value={item.id}>{item.title}</option>
                        )}
                    </Form.Select>

                </Form.Group>
            </div>
            <DataTable
                value={items}
                size="small"
                paginator
                rows={pageSize}
                totalRecords={totalRecords}
                lazy
                onPage={handlePagination}
                first={(pageIndex - 1) * pageSize} // Current first record index
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                tableStyle={{ minWidth: '50rem' }}
            >
                <Column
                    field="id"
                    header="ردیف"
                    style={{ width: '5%' }}
                    body={loading ? skeletonBodyTemplate : null}
                ></Column>
                <Column
                    field="departmentTitle"
                    header="دپارتمان"
                    style={{ width: '10%' }}
                    body={loading ? skeletonBodyTemplate : null}
                ></Column>
                <Column
                    field="subjectTitle"
                    header="موضوع"
                    style={{ width: '30px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    body={loading ? skeletonBodyTemplate : null}
                ></Column>
                <Column
                    field="fullName"
                    header="نام و نام خانوادگی"
                    style={{ width: '15%' }}
                    body={loading ? skeletonBodyTemplate : null}
                ></Column>
                <Column
                    field="phoneNumber"
                    header="شماره تماس"
                    style={{ width: '10%' }}
                    body={loading ? skeletonBodyTemplate : null}
                ></Column>
                <Column
                    field="message"
                    header="متن پیام"
                    style={{ width: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    body={loading ? skeletonBodyTemplate : null}
                ></Column>
                <Column
                    field="createDate"
                    header="تاریخ ثبت"
                    body={loading ? skeletonBodyTemplate : dateBodyTemplate}
                    style={{ width: '10%' }}
                ></Column>
            </DataTable>
        </div>
    );
}

export default Banner;
